(function () {
  function bindSingleOpen(root) {
    var handlers = [];
    root.querySelectorAll('details').forEach(function (detail) {
      function onToggle() {
        if (!detail.open) return;
        root.querySelectorAll('details').forEach(function (other) {
          if (other !== detail) {
            other.dataset.irFaqProgrammaticClose = '1';
            other.open = false;
            delete other.dataset.irFaqProgrammaticClose;
          }
        });
      }
      detail.addEventListener('toggle', onToggle);
      handlers.push({ detail: detail, fn: onToggle });
    });
    return handlers;
  }

  function bindAnswerHeightAnimations(root) {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cleanups = [];

    root.querySelectorAll('details.ir-faq-pill__item').forEach(function (details) {
      var shell = details.querySelector('.ir-faq-pill__answer-shell');
      var inner = shell && shell.querySelector('.ir-faq-pill__answer-inner');
      if (!shell || !inner) return;

      function setHeightPx(px) {
        shell.style.height = px + 'px';
      }

      function openHeight() {
        return inner.scrollHeight;
      }

      function syncOpenInstant() {
        setHeightPx(openHeight());
      }

      if (reduced) {
        details.addEventListener('toggle', function () {
          if (details.open) {
            shell.style.height = 'auto';
          } else {
            shell.style.height = '';
          }
        });
        if (details.open) {
          shell.style.height = 'auto';
        }
        return;
      }

      function onToggle() {
        if (details.open) {
          setHeightPx(0);
          void shell.offsetHeight;
          setHeightPx(openHeight());
          return;
        }
        if (details.dataset.irFaqProgrammaticClose === '1') {
          setHeightPx(0);
          return;
        }
        setHeightPx(0);
      }

      function onBeforeToggle(e) {
        if (e.newState !== 'closed' || !e.isTrusted) return;
        var h = openHeight();
        if (h <= 0) return;
        if (!e.cancelable) return;
        try {
          e.preventDefault();
        } catch (err) {
          return;
        }
        setHeightPx(h);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            setHeightPx(0);
          });
        });
        var settled = false;
        function finishClose() {
          if (settled) return;
          settled = true;
          clearTimeout(fallbackTimer);
          shell.removeEventListener('transitionend', onEnd);
          details.removeAttribute('open');
        }
        function onEnd(ev) {
          if (ev.target !== shell || ev.propertyName !== 'height') return;
          finishClose();
        }
        var fallbackTimer = setTimeout(finishClose, 600);
        shell.addEventListener('transitionend', onEnd);
      }

      details.addEventListener('toggle', onToggle);
      details.addEventListener('beforetoggle', onBeforeToggle);

      var ro = new ResizeObserver(function () {
        if (!details.open) return;
        setHeightPx(openHeight());
      });
      ro.observe(inner);
      cleanups.push({ ro: ro, inner: inner });

      if (details.open) {
        syncOpenInstant();
      } else {
        setHeightPx(0);
      }
    });

    return cleanups;
  }

  class IrFaqPillSection extends HTMLElement {
    connectedCallback() {
      this._roCleanups = bindAnswerHeightAnimations(this);
      if (this.hasAttribute('data-ir-faq-pill-single')) {
        this._handlers = bindSingleOpen(this);
      }
    }

    disconnectedCallback() {
      if (this._handlers) {
        this._handlers.forEach(function (h) {
          h.detail.removeEventListener('toggle', h.fn);
        });
        this._handlers = null;
      }
      if (this._roCleanups) {
        this._roCleanups.forEach(function (c) {
          c.ro.disconnect();
        });
        this._roCleanups = null;
      }
    }
  }

  if (customElements.get('ir-faq-pill-section') === undefined) {
    customElements.define('ir-faq-pill-section', IrFaqPillSection);
  }
})();
